/**
 * useArticles
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import ArticlesCartegoriesContext from './articles-categories-context'

const useArticlesCategories = () => {
  const context = useContext(ArticlesCartegoriesContext)

  return context
}

export default useArticlesCategories
